import createReactComponent from '../createReactComponent';
var EqualNot = createReactComponent('EqualNot', [['line', {
  x1: '5',
  y1: '9',
  x2: '19',
  y2: '9',
  key: 'p612hi'
}], ['line', {
  x1: '5',
  y1: '15',
  x2: '19',
  y2: '15',
  key: 'e39u1i'
}], ['line', {
  x1: '19',
  y1: '5',
  x2: '5',
  y2: '19',
  key: 't1677v'
}]]);
export default EqualNot;